import Box from "@mui/material/Box";

import VerticalMenuPage from "./VerticalMenuPage";
import HorizontalMenuPage from "./HorizontalMenuPage";

import KioskTimeout from "../../components/KioskTimeout/KioskTimeout";
import MultipleLayersMenuPage from "./MultipleLayersMenuPage/MultipleLayersMenuPage";
import { useAppSelector } from "../../../global/utils/redux/store";
import WelcomePopupScreen from "../../../qr/components/WelcomePopupScreen";
import { OnetimeUpsell } from "../../../global/utils/hooks/useOpenOneTimeUpsellDialog";
import { PiggyScanCardDialog } from "../../components/piggy/PiggyScanCardDialog";
import CikamDialog from "../../../global/components/Cikam/CikamDialog";
import { ScrollToArticleGroup } from "../../utils/ScrollToArticleGroup.tsx";
import { CatalogView } from "../../../global/utils/types/CatalogView.ts";
import PiggyDialog from "../../components/piggy/PiggyDialog.tsx";
import AiUpsellService from "../../../qr/components/AiUpsell/AiUpsellService.tsx";
import BavarianVouchersDialog from "../../components/piggy/BavarianVouchersDialog.tsx";

export default function MenuPage() {
  const catalogView: CatalogView = useAppSelector((state) => state.global.salesarea?.orientation_of_categories);
  const shouldShowWelcomePopup = useAppSelector((state) => state.global.salesarea?.show_welcome_screen);
  const venueId = useAppSelector((state) => state.global.salesarea?.venue_id);

  return (
    <>
      <ScrollToArticleGroup />
      <Box
        data-cy={"menu-page"}
        sx={{
          width: 1,
          height: 1,
          display: "flex",
          flexDirection: catalogView !== "VERTICAL" ? "column" : "row",
        }}
      >
        {shouldShowWelcomePopup ? <WelcomePopupScreen /> : null}
        <PiggyScanCardDialog />
        {venueId == 1647 ? <BavarianVouchersDialog /> : <PiggyDialog />}
        <KioskTimeout />
        <AiUpsellService />

        {catalogView === "VERTICAL" ? <VerticalMenuPage /> : null}

        {catalogView === "HORIZONTAL" ? <HorizontalMenuPage /> : null}
        {catalogView === "MULTIPLE_LAYERS" ? <MultipleLayersMenuPage /> : null}
      </Box>
      <CikamDialog />
      <OnetimeUpsell where={"onOpenMenuPage"} />
    </>
  );
}
